import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {PowerBiObjectModel} from '../../_models/DAL/PowerBiObject.model';
import {MicrosoftGraphService} from '../../_services/microsoftGraph.service';
import {AuthenticationService} from '../../_services/authentication.service';
import {User} from '../../_models/user.model';
import {ApiClhubService} from '../../_services/apiClhub.service';
import {Observable, Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {UserOrGroupModel} from '../../_models/DAL/UserOrGroup.model';
import {FavoritePowerBIObjectModel} from '../../_models/DAL/FavoritePowerBIObject.model';

@Component({
  selector: 'app-power-bi-object-list',
  templateUrl: './power-bi-object-list.component.html',
  styleUrls: ['./power-bi-object-list.component.css'],
})

export class PowerBiObjectListComponent implements OnInit, OnDestroy {

  constructor(private _azureService: MicrosoftGraphService, private _authenticationService: AuthenticationService,
              private _apiCLHUBClient: ApiClhubService, private _cdRef: ChangeDetectorRef, private _router: Router,
              private _route: ActivatedRoute) {

    this._currentUser = _authenticationService.currentUserValue;

    this._powerBIObjectSubject = new Subject<PowerBiObjectModel>();
    this.PowerBiObject = this._powerBIObjectSubject.asObservable();

    this._addPowerBiObject = new Subject<PowerBiObjectModel>();
    this._addPowerBiObjectFavorite = new Subject<PowerBiObjectModel>();

    this.displayPowerBiObject();
    this.displayPowerBiObjectFavorite();

    this.IsReportRoute = this._route.routeConfig.data.isReport;
  }

  get powerBiObjectsFavorites(): PowerBiObjectModel[] {
    return this._powerBiObjectsFavorites;
  }
  set powerBiObjectsFavorites(value: PowerBiObjectModel[]) {
    this._powerBiObjectsFavorites = value;
  }
  get powerBiObjects(): PowerBiObjectModel[] {
    return this._powerBiObjects;
  }
  set powerBiObjects(value: PowerBiObjectModel[]) {
    this._powerBiObjects = value;
  }

  private _powerBiObjects: PowerBiObjectModel[] = [];
  private _powerBiObjectsFavorites: PowerBiObjectModel[] = [];
  private _currentUser: User;
  private _powerBIObjectSubject: Subject<PowerBiObjectModel>;
  private _addPowerBiObject: Subject<PowerBiObjectModel>;
  private _addPowerBiObjectFavorite: Subject<PowerBiObjectModel>;
  private _numberOfPowerBiObject: number = 0;
  private _numberOfPowerBiObjectProcessed: number = 0;

  public IsReportRoute: boolean;
  public PowerBiObject: Observable<PowerBiObjectModel>;
  public EmptyResult: boolean = false;
  public EmptyResultFavorite: boolean = false;

  static sortList(a: PowerBiObjectModel, b: PowerBiObjectModel) {
    if (a.customName && b.customName) {
      return (a.customName > b.customName) ? 1 : ((b.customName > a.customName) ? -1 : 0);
    } else if (a.name && b.customName) {
      return (a.name > b.customName) ? 1 : ((b.customName > a.name) ? -1 : 0);
    } else if (a.customName && b.name) {
      return (a.customName > b.name) ? 1 : ((b.name > a.customName) ? -1 : 0);
    } else if (a.name && b.name) {
      return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
    }
  }

  ngOnInit(): void {
    this._azureService.GraphClientSubject.subscribe((client) => {
      if (client !== undefined) {
        client.api('https://graph.microsoft.com/v1.0/me/').get().then(me => {
          client.api('https://graph.microsoft.com/v1.0/me/memberOf').get().then(memberOf => {

            const listOfId = [];
            if (!this._currentUser.groupsid || this._currentUser.groupsid.length <= 0) {
              for (const group of memberOf.value) {
                listOfId.push(group.id);
              }
              this._currentUser.groupsid = listOfId;
              this._authenticationService.currentUserValue = this._currentUser;
            } else {
              for (const group of this._currentUser.groupsid) {
                listOfId.push(group);
              }
            }

            listOfId.push(me.id);

            this._apiCLHUBClient.post('PowerBiObject/getAllObjectForUserAndGroups',
                                          {'listOfId': listOfId, 'isReport': this.IsReportRoute}).subscribe(powerBiObjects => {
              if (powerBiObjects.length > 0) {
                this._numberOfPowerBiObject = powerBiObjects.length;
                for (const powerBiObject of powerBiObjects) {
                  this._powerBIObjectSubject.next(powerBiObject);
                }
              } else {
                this.EmptyResult = true;
                this.EmptyResultFavorite = true;
              }
            });

          });
        });
      }
    });

    this.getPropertyOfPowerBiObject();
  }

  ngOnDestroy(): void {
  }

  private getPropertyOfPowerBiObject() {
    this.PowerBiObject.subscribe(powerBiObject => {
      let URLToGetObject = '';
      if (this.IsReportRoute) {
        URLToGetObject = 'PowerBi/getReport?reportId=' + powerBiObject.azureObjectId + '&groupId=' + powerBiObject.azureWorkspaceId;
      } else {
        URLToGetObject = 'PowerBi/getDashboard?dashboardId=' + powerBiObject.azureObjectId + '&groupId=' + powerBiObject.azureWorkspaceId;
      }

      this._apiCLHUBClient.get(URLToGetObject)
        .subscribe(powerBiResultReport => {
          if (powerBiResultReport) {

            if (this.IsReportRoute) {
              powerBiObject.name = powerBiResultReport.name;
            } else {
              powerBiObject.name = powerBiResultReport.displayName;
            }

            this._apiCLHUBClient.post(
              'FavoritePowerBIObject/filtered-list',
              {'UserOrGroupId': this._authenticationService.currentUserValue.userOrGroupId, 'PowerBIObjectId': powerBiObject.id}
            ).subscribe(favoritePowerBIObject => {
              if (favoritePowerBIObject && favoritePowerBIObject.length > 0) {
                this._addPowerBiObjectFavorite.next(powerBiObject);
              } else {
                this._addPowerBiObject.next(powerBiObject);
              }
              this._numberOfPowerBiObjectProcessed++;

              if (this._numberOfPowerBiObject === this._numberOfPowerBiObjectProcessed) {

                if (this._powerBiObjectsFavorites.length === 0) { this.EmptyResultFavorite = true; }
                if (this._powerBiObjects.length === 0) { this.EmptyResult = true; }

                this._cdRef.detectChanges();
              }
            });
          }
        });

    });
  }

  goToView(powerBiObject: PowerBiObjectModel) {
    const idPowerBiObject = powerBiObject ? powerBiObject.id : null;
    if (this.IsReportRoute) {
      this._router.navigate(['bi/report/view', idPowerBiObject]);
    } else {
      this._router.navigate(['bi/dashboard/view', idPowerBiObject]);
    }
  }

  removeFromFavorite(powerBiObject: PowerBiObjectModel) {

    this._apiCLHUBClient.post('FavoritePowerBIObject/filtered-list',
                                {'UserOrGroupId': this._currentUser.userOrGroupId, 'PowerBIObjectId': powerBiObject.id})
      .subscribe(resultFilteredList => {

        if (resultFilteredList && resultFilteredList.length > 0) {
          this._apiCLHUBClient.delete('FavoritePowerBIObject/' + resultFilteredList[0].id, null)
            .subscribe(idDeleted => {

              const index = this.powerBiObjectsFavorites.findIndex(obj => obj.id === powerBiObject.id);
              this.powerBiObjects.push(this.powerBiObjectsFavorites[index]);
              this.powerBiObjectsFavorites.splice(index, 1);
              this.powerBiObjectsFavorites.sort(PowerBiObjectListComponent.sortList);
              this.powerBiObjects.sort(PowerBiObjectListComponent.sortList);
              if (this.powerBiObjectsFavorites.length === 0 ) {
                this.EmptyResultFavorite = true;
              }
          });
        }
      });
  }

  addToFavoriteReport(powerBiObject: PowerBiObjectModel) {
    // get user
    const userRequest = this._apiCLHUBClient.post('UserOrGroup/filtered-list', {'AzureObjectId' : this._currentUser.azure_id});

    userRequest.subscribe((Users: UserOrGroupModel[]) => {

      // si l'utilisateur n'éxiste pas, création (accès via groupe par exemple)
      if (Users.length === 0) {
        const UserOrGroup = new UserOrGroupModel();
        UserOrGroup.azureObjectId = this._currentUser.azure_id;
        UserOrGroup.isUser = true;
        UserOrGroup.isGroup = false;
        this._apiCLHUBClient.post('UserOrGroup', UserOrGroup).subscribe((idUser) => {
          UserOrGroup.id = idUser;
          this.addFavoriteReport(UserOrGroup, powerBiObject);
        });
      } else {
        this.addFavoriteReport(Users[0], powerBiObject);
      }
    });
  }

  /*
  Ajout du rapport favoris
 */
  private addFavoriteReport(userOrGroup: UserOrGroupModel, powerBiObject: PowerBiObjectModel) {
    const favoriteReport = new FavoritePowerBIObjectModel();

    favoriteReport.userOrGroupId = userOrGroup.id;
    favoriteReport.powerBIObjectId = powerBiObject.id;

    if (userOrGroup.isUser) {
      this._apiCLHUBClient.post('FavoritePowerBIObject', favoriteReport).subscribe((idFavoriteReport) => {
        favoriteReport.id = idFavoriteReport;
        const index = this.powerBiObjects.findIndex(obj => obj.id === powerBiObject.id);
        this.powerBiObjectsFavorites.push(this.powerBiObjects[index]);
        this.powerBiObjects.splice(index, 1);
        this.powerBiObjectsFavorites.sort(PowerBiObjectListComponent.sortList);
        this.powerBiObjects.sort(PowerBiObjectListComponent.sortList);
        if (this.powerBiObjects.length === 0 ) {
          this.EmptyResult = true;
        }
      });
    }
  }

  private displayPowerBiObject() {
    this._addPowerBiObject.asObservable().subscribe((powerBiObject) => {
      if (!this._powerBiObjects.find(obj => obj.id === powerBiObject.id)) {
        this._powerBiObjects.push(powerBiObject);
        this._powerBiObjects.sort(PowerBiObjectListComponent.sortList);
        this._cdRef.detectChanges();
      }
    });
  }

  private displayPowerBiObjectFavorite() {
    this._addPowerBiObjectFavorite.asObservable().subscribe((powerBiObject) => {
      if (!this._powerBiObjectsFavorites.find(obj => obj.id === powerBiObject.id)) {
        this._powerBiObjectsFavorites.push(powerBiObject);
        this._powerBiObjectsFavorites.sort(PowerBiObjectListComponent.sortList);
        this._cdRef.detectChanges();
      }
    });
  }
}
